/**
 * Section: Fleurs fraîches à la botte — filtres catégories + carousel
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.ffabBound === '1') return;

    var cats = root.querySelectorAll('[data-ffab-cat]');
    var slides = root.querySelectorAll('[data-ffab-product]');
    var track = root.querySelector('[data-ffab-track]');
    var prev = root.querySelector('[data-ffab-prev]');
    var next = root.querySelector('[data-ffab-next]');

    if (!cats.length || !slides.length || !track) return;

    var state = { catKey: '' };

    function productMatches(slide) {
      var pCat = slide.getAttribute('data-ffab-parent-cat') || '';
      return pCat === state.catKey;
    }

    function applyFilter() {
      slides.forEach(function (slide) {
        var match = productMatches(slide);
        if (match) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });
      track.scrollLeft = 0;
      updateNav();
    }

    function setActiveCat(btn) {
      cats.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function selectCat(btn) {
      if (!btn) return;
      state.catKey = btn.getAttribute('data-ffab-cat-key') || '';
      setActiveCat(btn);
      applyFilter();
    }

    function visibleWidth() {
      return track.clientWidth * 0.92;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = maxScroll();
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4 || max <= 4;
    }

    cats.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectCat(btn);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -visibleWidth(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: visibleWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    root.dataset.ffabBound = '1';
    selectCat(cats[0]);
  }

  function run(scope) {
    var roots = (scope || document).querySelectorAll('[data-ffab-section]');
    roots.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) run(e.target);
  });
})();
